import React, { FC, useContext, useState } from 'react'

import { Button } from '../ui/button'
import { Input } from '../ui/input'

import { getFloatPrice } from '../../helpers/price'
import { cn } from '../../lib/utils'

import { MODAL_CONSTS } from '../../const/modal-const'
import { HandleModalContext } from '../../layout/mainlayout/MainLayout'

type TicketsColumnProps = {
  loading: boolean
  currency: string
  name: string | null
  price: number | null
  available: number
  description: string | null
  onBlur: (value: number) => void
  defaultValue: number
}

export const TicketsColumn: FC<TicketsColumnProps> = ({
  name,
  price,
  available,
  description,
  defaultValue,
  onBlur,
  loading,
  currency,
}) => {
  const handleModal = useContext(HandleModalContext)?.handleModal

  const [inputValue, setInputValue] = useState<string | number>(defaultValue)

  const openSeeMoreModal = (content: string) => {
    handleModal?.(true, MODAL_CONSTS.ADD_NOTE, { noteInputRef: content })
  }

  return (
    <div className="flex flex-wrap items-center justify-between w-full gap-2 border-b border-b-black/10 py-4">
      <div className="w-full sm:max-w-[50%]">
        <h6 className="text-sm font-normal">{name || 'No title'}</h6>
        <div className="flex flex-wrap items-center gap-1 text-xs text-black/50 mt-1">
          <p>{getFloatPrice(`${currency}${price}`)}</p>
          <span>•</span>
          <p>{!isNaN(Number(available)) ? `${available} remaining` : 'N/A'}</p>
          <span>•</span>
          <Button
            variant="underline"
            className="text-xs text-black/50 p-0 bg-transparent"
            onClick={() => openSeeMoreModal(description || 'No description')}
          >
            More
          </Button>
        </div>
      </div>
      <Input
        type="number"
        name="available"
        disabled={loading || available <= 0}
        onChange={(e) => {
          const raw = e.target.value
          const normalized = raw === '' ? '' : String(Number(raw))
          if (Number(normalized) > Number(available)) setInputValue(available)
          else setInputValue(normalized)
        }}
        className={cn(
          'w-full sm:w-[160px] text-center p-3 h-auto',
          inputValue > 0 && 'bg-SeabiscuitGrayThemeColor border-SeabiscuitGrayThemeColor'
        )}
        placeholder={available <= 0 ? 'No available' : 'Enter units'}
        value={inputValue}
        onBlur={(event) => onBlur(Number(event.target.value))}
      />
    </div>
  )
}
